<template>
  <transition name="openMenu">
    <div class="open-menu-container" @mousewheel.prevent v-show="menuShow">
      <div class="menu-header">
        <div class="logo-container">
          <img src="../assets/image/menu-logo.png" alt="" />
          <div class="title">
            <span>为改变</span>
          </div>
        </div>
        <div class="menu-btn-container">
          <div class="language-btn">
            <span>简体中文</span>
          </div>
          <div class="menu-btn" @click="close">
            <img src="../assets/image/icon-close.png" alt="" />
          </div>
        </div>
      </div>
      <div class="menu-body">
        <div class="body-left">
          <div class="title">
            提交您的需求，<span style="color: #0057ff">改变</span>即刻开始
          </div>
          <div class="demand-container">
            <div class="title"><span>服务需求</span></div>
            <div class="btns-container">
              <div
                class="btn"
                :class="{ active: activeDemandIndex == item.id }"
                v-for="item in demandTypeData"
                :key="item.id"
                @click="activeDemandIndexChange(item.id)"
              >
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
          <div class="contact-form-container">
            <div class="title"><span>联系方式</span></div>
            <div class="input-container">
              <input
                type="text"
                placeholder="填写您的名字"
                v-model="userMsgdata.username"
              />
              <input
                type="text"
                placeholder="填写您的手机号"
                v-model="userMsgdata.phone"
              />
            </div>
            <div class="submit-btn">
              <span>提交</span>
            </div>
          </div>
        </div>
        <div class="body-right">
          <ul>
            <li
              v-for="(item, index) in menuList"
              :key="index"
              :class="{ active: activeMenuIndex == index }"
              @click="activeMenuIndexChange(index)"
            >
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      menuShow: false,
      activeMenuIndex: 0,
      activeDemandIndex: 1,
      menuList: [
        "首页",
        "案例展示",
        "解决方案",
        "服务内容",
        "联系我们",
        "关于我们",
      ],
      demandTypeData: [
        { id: 1, name: "产品设计" },
        { id: 2, name: "软件开发" },
        { id: 3, name: "品牌设计" },
        { id: 4, name: "微信开发" },
        { id: 5, name: "方案咨询" },
        { id: 6, name: "网站定制" },
        { id: 7, name: "其他服务" },
      ],
      userMsgdata: {
        username: null,
        phone: null,
        demandId: null,
      },
    };
  },
  methods: {
    open() {
      this.menuShow = true;
      if (this.$route.name == "details") {
        this.activeMenuIndex = this.$route.query.menuIndex;
      }
    },
    close() {
      this.menuShow = false;
    },
    activeMenuIndexChange(index) {
      if (index != this.activeMenuIndex) {
        if (index == 0) {
          this.$router.push("/home");
        } else {
          this.$router.push({
            path: "/details",
            query: {
              menuIndex: index,
            },
          });
        }
      }
      // this.activeMenuIndex = index;
    },
    activeDemandIndexChange(index) {
      this.activeDemandIndex = index;
      this.userMsgdata.demandId = index;
    },
    initActiveMenuIndex() {
      this.activeMenuIndex = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.openMenu-enter-active,
.openMenu-leave-active {
  transition: opacity 0.3s;
}
.openMenu-enter,
.openMenu-leave-to {
  opacity: 0;
}
.open-menu-container {
  position: fixed;
  z-index: 2;
  top: 0;
  width: 100%;
  min-width: 1240px;
  height: 100vh;
  background: #fff;
  .menu-header {
    height: 74px;
    padding: 0 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo-container {
      display: flex;
      align-items: center;
      img {
        display: block;
        width: 107px;
        height: 20px;
        margin-right: 12px;
      }
      .title {
        height: 16px;
        border-left: 1px solid #c5c5c5;
        display: flex;
        align-items: center;
        padding-left: 12px;
        span {
          font-family: PingFangSC-Medium;
          font-size: 20px;
          color: #000000;
          text-align: center;
        }
      }
    }
    .menu-btn-container {
      display: flex;
      .language-btn {
        width: 90px;
        height: 34px;
        border: 1px solid #000000;
        border-radius: 17px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        margin-right: 20px;
        cursor: pointer;
        user-select: none;
      }
      .menu-btn {
        width: 34px;
        box-sizing: border-box;
        cursor: pointer;
        user-select: none;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          display: block;
          width: 23px;
          height: 23px;
        }
      }
    }
  }
  .menu-body {
    padding: 86px 120px 0 120px;
    display: flex;
    .body-left {
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 40px;
        color: #000000;
      }
      .demand-container {
        margin-top: 40px;
        .title {
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          color: #000000;
        }
        .btns-container {
          width: 570px;
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;
          .btn {
            width: 104px;
            height: 40px;
            margin: 10px 10px 0 0;
            background: #efeef2;
            border-radius: 20px;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #000000;
            line-height: 26px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            user-select: none;
            &:hover {
              background: #ddd;
              transition: all 0.4s;
            }
          }
          .active {
            background: #000000 !important;
            color: #ffffff;
          }
        }
      }
      .contact-form-container {
        margin-top: 40px;
        .title {
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          color: #000000;
        }
        .input-container {
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          input {
            width: 300px;
            height: 40px;
            margin-bottom: 20px;
            box-sizing: border-box;
            padding: 7px 20px;
            border: 1px solid #000000;
            border-radius: 20px;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #848484;
            line-height: 26px;
          }
        }
        .submit-btn {
          width: 300px;
          height: 50px;
          margin-top: 20px;
          background: #0057ff;
          border-radius: 25px;
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #ffffff;
          line-height: 26px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          user-select: none;
          &:active {
            opacity: 0.8;
          }
        }
      }
    }
    .body-right {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      ul {
        li {
          margin-bottom: 30px;
          font-family: PingFangSC-Semibold;
          font-size: 30px;
          color: #000000;
          cursor: pointer;
          user-select: none;
          &:hover {
            span {
              display: block;
              color: #005dff;
              transform: translateX(-20px);
              transition: all 0.2s;
            }
          }
        }
        .active {
          position: relative;
          color: #005dff;
          transform: translateX(-20px);
          &::after {
            position: absolute;
            top: 17px;
            right: -140px;
            display: block;
            content: "";
            width: 120px;
            height: 6px;
            background: #005dff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/openMenu.vue